$(document).ready(function() {

    var updateFilename = function(input){
        var filename = $(input).val();
        var filenameParts = filename.split('.');
        var extension = filenameParts[filenameParts.length-1];

        var backgroundImage = '/web/images/';
        var isDoc = true;
        switch (extension) {
            case 'pdf':
            backgroundImage += 'pdf.png';
                break;
            case 'doc':
            backgroundImage += 'doc.png';
                break;
            case 'docx':
            backgroundImage += 'doc.png';
                break;
            default:
                isDoc = false;
                break
        }

        if(isDoc){
            $(input).parent().css('background-image',"url('" + backgroundImage + "')").css('opacity',0.6);
            $(input).next('span.filename').text('').text(filename);
        }

    };

    $('.image-preview  input[type=file]').change(function(){
        updateFilename(this);
    });

    $(".image-preview").each(
            function(){
                $.uploadPreview({
                    input_field: $(this).find('input[type=file]'),   // Default: .image-upload
                    preview_box: this,  // Default: .image-preview
                    label_field: $(this).find("#image-label"),    // Default: .image-label
                    label_default: "Carregar",   // Default: Choose File
                    label_selected: "Alterar",  // Default: Change File
                    no_label: false,        // Default: false
                });
            }
        );
});